interface RoleBadgeProps {
    isAdmin: boolean;
}

// One restrained tint for Admin; User stays neutral - matches the design
// source's ac-users.jsx RoleBadge (violet bg-[#EDE9FE] text-[#5B45C7]).
export function RoleBadge({ isAdmin }: RoleBadgeProps) {
    return (
        <span
            className={`inline-flex items-center h-6 px-2 rounded-full text-[11px] font-bold whitespace-nowrap ${
                isAdmin ? 'bg-[#EDE9FE] text-[#5B45C7]' : 'bg-gray-100 text-gray-600'
            }`}
        >
            {isAdmin ? 'Admin' : 'User'}
        </span>
    );
}
